import Vue from 'vue'
import VueRouter from 'vue-router'
import wap from '@/components/wap'
import wapPage from '@/components/wapPage'
import index from '@/components/index'
import about from '@/components/about'
import introduced from '@/components/introduced'
import insuranceList from '@/components/insuranceList'
import login from '@/components/login'
import orderDetails from '@/components/product/chinaLifeAccidentInsurance/orderDetails'
import orderManagement from '@/components/product/chinaLifeAccidentInsurance/orderManagement'
import policyManagement from '@/components/product/chinaLifeAccidentInsurance/policyManagement'
import insureManagement from '@/components/product/chinaLifeAccidentInsurance/insureManagement'
import insureConfirm from '@/components/product/chinaLifeAccidentInsurance/insureConfirm'
import insureDetails from '@/components/product/chinaLifeAccidentInsurance/insureDetails'
import quotationManagement from '@/components/product/chinaLifeAccidentInsurance/quotationManagement'
import quotationDetails from '@/components/product/chinaLifeAccidentInsurance/quotationDetails'
import orderPaymentType from '@/components/product/chinaLifeAccidentInsurance/orderPaymentType'
import quoteMainSaveSuccess from '@/components/product/chinaLifeAccidentInsurance/quoteMainSaveSuccess'
import personnelManagement from '@/components/product/chinaLifeAccidentInsurance/preservation/personnelManagement'
import correctingHistoryManagement from '@/components/product/chinaLifeAccidentInsurance/preservation/correctingHistoryManagement'
import correctingHistoryDetails from '@/components/product/chinaLifeAccidentInsurance/preservation/correctingHistoryDetails'
import securityPayment from '@/components/product/chinaLifeAccidentInsurance/preservation/securityPayment'
import personnelCorrecting from '@/components/product/chinaLifeAccidentInsurance/preservation/personnelCorrecting'
import personnelConfirmation from '@/components/product/chinaLifeAccidentInsurance/preservation/personnelConfirmation'
import productShowDetail from '@/components/product/chinaLifeAccidentInsurance/productShowDetail'
import sinosafeInsureManagement from '@/components/product/sinosafeInsurance/sinosafeInsureManagement'
import siNoSafeInsureDetails from '@/components/product/sinosafeInsurance/siNoSafeInsureDetails'
import siNoSafeInsureConfirm from '@/components/product/sinosafeInsurance/siNoSafeInsureConfirm'
import siNoSafeOrderDetails from '@/components/product/sinosafeInsurance/siNoSafeOrderDetails'
import ejsinoInsureDetails from '@/components/product/employerInsurance/ejsinoInsureDetails'
import dutyInsuranceFillInfo from '@/components/product/dutyInsurance/fillInfo'
import dutyInsuranceOrderManagement from '@/components/product/dutyInsurance/orderManagement'
import dutyInsuranceInsuranceManagement from '@/components/product/dutyInsurance/insuranceManagement'
import dutyInsuranceOrderDetails from '@/components/product/dutyInsurance/orderDetails'
import qnaDetails from '@/components/product/employerInsurance/qnaDetails'
import dutyInsuranceOfferTesting from '@/components/product/dutyInsurance/offerTesting'
import dutyInsuranceMyInvitation from '@/components/product/dutyInsurance/myInvitation'
import haoLianPage from '@/components/product/haoLian/haoLian'
import haoLianIndex from '@/components/product/haoLian/index'
import haoLianOfferTesting from '@/components/product/haoLian/offerTesting'
import haoLianFillInfo from '@/components/product/haoLian/fillInfo'
import haoLianOrderManagement from '@/components/product/haoLian/orderManagement'
import haoLianInsuranceManagement from '@/components/product/haoLian/insuranceManagement'
import haoLianOrderDetails from '@/components/product/haoLian/orderDetails'
import sskProductDetailPage from '@/components/product/ssk/productDetailPage'
import sskInfoFillingPage from '@/components/product/ssk/infoFillingPage'
import sskGuaranteeDetailPage from '@/components/product/ssk/guaranteeDetailPage'
import zfbProductDetailPage from '@/components/product/zfb/productDetailPage'
import zfbInfoFillingPage from '@/components/product/zfb/infoFillingPage'
import tkVehicleInfo from '@/components/product/autoInsurance/taikang/vehicleInfo'
import tkPremiumCalculation from '@/components/product/autoInsurance/taikang/premiumCalculation'
import tkFillInfo from '@/components/product/autoInsurance/taikang/fillInfo'
import tkOrderDetail from '@/components/product/autoInsurance/taikang/orderDetail'
import buyerPaymentGuaranteeInsurance from '@/components/product/modernPropertyInsurance/buyerPaymentGuaranteeInsurance'
import domesticTradeCredit_productDetail from '@/components/product/domesticTradeCredit/productDetail'
import domesticTradeCredit_insureInfo from '@/components/product/domesticTradeCredit/insureInfo'
import domesticTradeCredit_orderDetail from '@/components/product/domesticTradeCredit/orderDetail'

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new VueRouter({
  // mode: 'hash',  // 链接带#号
  mode: 'history',  // 链接不带#号
  routes: [
    {
      // 首页
      path: '/',
      name: 'vue',
      component: wap,
      meta: {
        auth: true,
        leaf: false,
        hidden: false,
      },
      children: [
        {
          path: '/',
          name: 'index',
          component: index
        },
        {
          path: '/index',
          name: 'indexNew',
          component: index
        },
        {
          // 介绍页
          path: 'introduced',
          name: 'introduced',
          component: introduced
        },
        {
          // 投保列表
          path: 'insuranceList',
          name: 'insuranceList',
          component: insuranceList
        },
        {
          // 登录、注册
          path: 'login',
          name: 'login',
          component: login
        },
        {
          // 国寿财团意险 - 产品方案报价书
          path: 'quotationDetails/:quoteMainId/:userMember',
          name: 'quotationDetails',
          component: quotationDetails
        },
        {
          // 国寿财团意险 - 订单详情
          path: 'orderDetails',
          name: 'orderDetails',
          component: orderDetails
        },
        {
          // 国寿财团意险 - 投保3 - 支付页
          path: 'orderPaymentType',
          name: 'orderPaymentType',
          component: orderPaymentType
        },
        {
          // 国寿财团意险 - 报价单生成成功页
          path: 'quoteMainSaveSuccess',
          name: 'quoteMainSaveSuccess',
          component: quoteMainSaveSuccess
        },
        {
          // 国寿财团意险 - 投保2-1 填写投保基本信息
          path: 'insureDetails',
          name: 'insureDetails',
          component: insureDetails
        },
        {
          // 国寿财团意险 - 投保2-2 确认投保信息
          path: 'insureConfirm',
          name: 'insureConfirm',
          component: insureConfirm
        },
        {
          // 国寿财团意险 - 投保1 = 选择投保方案
          path: 'insureManagement',
          name: 'insureManagement',
          component: insureManagement
        },
        {
          // 国寿财团意险 - 保全 - 批改历史详情
          path: 'correctingHistoryDetails',
          name: 'correctingHistoryDetails',
          component: correctingHistoryDetails
        },
        {
          // 国寿财团意险 - 保全 - 支付页
          path: 'securityPayment',
          name: 'securityPayment',
          component: securityPayment
        },
        {
          // 国寿财团意险 - 保全 - 人员增减（编辑）
          path: 'personnelCorrecting',
          name: 'personnelCorrecting',
          component: personnelCorrecting
        },
        {
          // 国寿财团意险 - 保全 - 人员增减（确认）
          path: 'personnelConfirmation',
          name: 'personnelConfirmation',
          component: personnelConfirmation
        },
        {
          path: 'about',
          name: 'about',
          component: about
        },
        {
          path: 'productShowDetail/:showType',
          name: 'productShowDetail',
          component: productShowDetail
        },
        {
          // 餐小保 - 投保
          path: 'sinosafeInsureManagement',
          name: 'sinosafeInsureManagement',
          component: sinosafeInsureManagement
        },
        {
          // 餐小保 - 投保 - 填写投保资料
          path: 'siNoSafeInsureDetails',
          name: 'siNoSafeInsureDetails',
          component: siNoSafeInsureDetails
        },
        {
          // 餐小保 - 投保 - 确认订单
          path: 'siNoSafeInsureConfirm',
          name: 'siNoSafeInsureConfirm',
          component: siNoSafeInsureConfirm
        },
        {
          // 餐小保 - 投保 - 订单详情
          path: 'siNoSafeOrderDetails',
          name: 'siNoSafeOrderDetails',
          component: siNoSafeOrderDetails
        },
        {
          // E超市 - 投保 - 产品详情
          path: 'ejsinoInsureDetails',
          name: 'ejsinoInsureDetails',
          component: ejsinoInsureDetails
        },
        {
          // 通用 - 关税
          path: 'dutyInsurance/fillInfo',
          name: 'dutyInsuranceFillInfo',
          component: dutyInsuranceFillInfo
        },
        {
          // 关税险 - 订单详情
          path: 'dutyInsurance/orderDetails',
          name: 'dutyInsuranceOrderDetails',
          component: dutyInsuranceOrderDetails
        },
        {
          // E超市 - Q&A流程
          path: 'qnaDetails',
          name: 'qnaDetails',
          component: qnaDetails
        },
        {
          // 穗岁康 - 产品详情页
          path: 'sskProductDetailPage',
          name: 'sskProductDetailPage',
          component: sskProductDetailPage,
          meta: {
            title: '穗岁康 - 产品详情',
          },
        },
        {
          // 穗岁康 - 填写参保信息页
          path: 'sskInfoFillingPage',
          name: 'sskInfoFillingPage',
          component: sskInfoFillingPage,
          meta: {
            title: '穗岁康 - 填写参保信息',
          },
        },
        {
          // 穗岁康 - 保障详情页
          path: 'sskGuaranteeDetailPage',
          name: 'sskGuaranteeDetailPage',
          component: sskGuaranteeDetailPage,
          meta: {
            title: '穗岁康 - 保障详情',
          },
        },
        {
          // 肇福保 - 产品详情页
          path: 'zfbProductDetailPage',
          name: 'zfbProductDetailPage',
          component: zfbProductDetailPage,
          meta: {
            title: '肇福保 - 产品详情',
          },
        },
        {
          // 肇福保 - 填写参保信息页
          path: 'zfbInfoFillingPage',
          name: 'zfbInfoFillingPage',
          component: zfbInfoFillingPage,
          meta: {
            title: '肇福保 - 填写参保信息',
          },
        },
        {
          // 泰康车险 - 填写车辆信息
          path: '/taiKang/vehicleInfo',
          name: 'vehicleInfo',
          component: tkVehicleInfo,
          meta: {
            title: '填写信息',
          },
        },
        {
          // 泰康车险 - 保费计算
          path: '/taiKang/premiumCalculation',
          name: 'premiumCalculation',
          component: tkPremiumCalculation,
          meta: {
            title: '保费计算',
          },
        },
        {
          // 泰康车险 - 报价详情
          path: '/taiKang/fillInfo',
          name: 'fillInfo',
          component: tkFillInfo,
          meta: {
            title: '报价详情',
          },
        },
        {
          // 泰康车险 - 订单详情
          path: '/taiKang/orderDetail',
          name: 'orderDetail',
          component: tkOrderDetail,
          meta: {
            title: '订单详情',
          },
        },
        {
          // 现代财产保险（中国）有限公司 - 网络交易平台买家应付款保证保险
          path: '/modernPropertyInsurance/buyerPaymentGuaranteeInsurance',
          name: 'buyerPaymentGuaranteeInsurance',
          component: buyerPaymentGuaranteeInsurance,
          meta: {
            title: '产品介绍',
          },
        },
        {
          // 现代财产保险（中国）有限公司 - 渠道产品 - 国内贸易信用险
          path: '/domesticTradeCredit/productDetail',
          name: 'domesticTradeCredit_productDetail',
          component: domesticTradeCredit_productDetail,
          meta: {
            title: '产品介绍',
          },
        },
        {
          // 现代财产保险（中国）有限公司 - 渠道产品 - 国内贸易信用险
          path: '/domesticTradeCredit/insureInfo',
          name: 'domesticTradeCredit_insureInfo',
          component: domesticTradeCredit_insureInfo,
          meta: {
            title: '投保页',
          },
        },
        {
          // 现代财产保险（中国）有限公司 - 渠道产品 - 国内贸易信用险
          path: '/domesticTradeCredit/orderDetail',
          name: 'domesticTradeCredit_orderDetail',
          component: domesticTradeCredit_orderDetail,
          meta: {
            title: '订单详情',
          },
        },
      ]
    },
    {
      path: '/wapPage',
      name: 'wapPage',
      component: wapPage,
      children: [
        {
          // 订单管理
          path: 'orderManagement',
          name: 'orderManagement',
          component: orderManagement
        },
        {
          // 保单管理
          path: 'policyManagement',
          name: 'policyManagement',
          component: policyManagement
        },
        {
          // 国寿财团意险 - 报价单管理
          path: 'quotationManagement',
          name: 'quotationManagement',
          component: quotationManagement
        },
        {
          // 保全 - 人员增减
          path: 'personnelManagement',
          name: 'personnelManagement',
          component: personnelManagement
        },
        {
          // 保全 - 批改历史
          path: 'correctingHistoryManagement',
          name: 'correctingHistoryManagement',
          component: correctingHistoryManagement
        },
        {
          // 关税订单管理
          path: 'dutyInsurance/orderManagement',
          name: 'dutyInsuranceOrderManagement',
          component: dutyInsuranceOrderManagement
        },
        {
          // 关税保单管理
          path: 'dutyInsurance/insuranceManagement',
          name: 'dutyInsuranceInsuranceManagement',
          component: dutyInsuranceInsuranceManagement
        },
        {
          // 关税个人中心 - 测一测
          path: 'dutyInsurance/offerTesting',
          name: 'offerTesting',
          component: dutyInsuranceOfferTesting
        },
        {
          // 关税个人中心 - 我的邀请
          path: 'dutyInsurance/myInvitation',
          name: 'myInvitation',
          component: dutyInsuranceMyInvitation
        },
      ]
    },
    {
      path: '/haoLian',
      name: 'haoLian',
      component: haoLianPage,
      children: [
        {
          // 管理列表
          path: '/',
          name: 'index',
          component: haoLianIndex
        },
        {
          // 关税个人中心 - 测一测
          path: 'offerTesting',
          name: 'offerTesting',
          component: haoLianOfferTesting
        },
        {
          // 关税个人中心 - 投保
          path: 'fillInfo',
          name: 'fillInfo',
          component: haoLianFillInfo
        },
        {
          // 关税订单管理
          path: 'orderManagement',
          name: 'orderManagement',
          component: haoLianOrderManagement
        },
        {
          // 关税保单管理
          path: 'insuranceManagement',
          name: 'insuranceManagement',
          component: haoLianInsuranceManagement
        },
        {
          // 关税产品详情
          path: 'orderDetails',
          name: 'orderDetails',
          component: haoLianOrderDetails
        },
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  /*scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },*/
})



// WEBPACK FOOTER //
// ./src/router/index.js